
import React, { useEffect, useState } from 'react';
import './index.less';
import Nav from '@/components/Nav';
import { useOutletContext, useNavigate } from 'react-router-dom';
import { LoginInfo } from '@/types';
import useSWR from 'swr';
import { getQuestionCount, getLastQuestionDetail } from '@/constants/api';
import { fetcher } from '@/utils/request';
import { useSetAtom } from 'jotai';
import {  loginAtom } from '@/utils/atoms';

const KfIndex = () => {
  const loginInfo: LoginInfo = useOutletContext();
  const [questions, setQuestions] = useState(0);
  const [detail, setDetail] = useState({
    questionOrStatus: '',
    statusOrGameName: '',
    type: 0,
  });
  const { data } = useSWR(getQuestionCount);
  const navigate = useNavigate();
  const setUpdateLogin = useSetAtom(loginAtom);

  useEffect(() => {
    if (!loginInfo?.isLogin) {
      setUpdateLogin({ isLogin: false, visibleLogin: true });
    }
  },[loginInfo?.isLogin]);

  useEffect(() => {
    if (data?.retCode === 'SUCCESS') {
      setQuestions(data.data);
    }
  }, [data]);

  useEffect(() => {
    fetcher(getLastQuestionDetail, { credentials: 'include' }).then(res => {
      if (res?.retCode === 'SUCCESS') {
        setDetail({
          questionOrStatus: res.data.questionOrStatus,
          statusOrGameName: res.data.statusOrGameName,
          type: res.data.type,
        });
      }
    });
  }, []);

  const login = () => {
    if (!loginInfo?.isLogin) {
      setUpdateLogin?.({ isLogin: false, visibleLogin: true });
    }
  };

  return (
    <div className='kfWarp'>
      <Nav activeMenu="kfCenter" />
      <div className='kfContent'>
        <div className='kfLeft'>
          <div className='title'>{loginInfo.account ? loginInfo.account : '您还未登录'}</div>

          {
            loginInfo.account ? <div>
              <div className='loginIn'>
                <p>您已提交<span style={{ color: '#c00' }}>{questions}</span>个问题</p>
                <p className='btnDetail' onClick={() => navigate('/kf/kfTrackIndex')}>查看详情</p>
              </div>
              {
                detail.type ? <div className='Question'>
                  <p>最新问题：{detail.questionOrStatus}</p>
                  <p>处理状态：<span style={{ color: '#c00' }}>{detail.statusOrGameName}</span></p>
                </div> : <div className='noQuestion'>
                  <p>您还没有提交问题</p>
                  <p className='btnDetail' onClick={() => window.location.href = 'http://kf.gyyx.cn/Home/IMIndex?opType=wegame'}>我要提问</p>
                </div>
              }
            </div> : <div>
              <div className='leftIcon'></div>
              <div className='serviceBox'>我的服务记录</div>
              <a className='pleaseLogin' onClick={() => login()}>请登录</a>
            </div>
          }

        </div>
        <div className='keRight'>
          <h3 className="wgContentTitle">
            <span>游戏问题服务</span>
          </h3>
          <ul className='rightUl'>
            <li onClick={() => navigate('/kf/kfItemsRecovered')}>
              <div className='gameItems'></div>
              <div className='gameText'>
                <h3>游戏物品被盗找回</h3>
                <p>游戏内物品被盗申诉找回</p>
              </div>
            </li>
            <li onClick={() => navigate('/kf/QiBaoItemsRecovered')}>
              <div className='appeal'></div>
              <div className='gameText'>
                <h3>奇宝斋物品交易申诉</h3>
                <p>若您对“奇宝斋”交易平台公示期和未出售成功的物品有异议（道具、宠物、装备等），需要申诉，请进入此通道
                  <span style={{ color: '#c00' }}>（注：已成功下订单出售的物品不予追查，请玩家及时申诉。）</span>
                </p>
              </div>
            </li>
            <li onClick={() => navigate('/kf/kfItemsResume')}>
              <div className='unseal'></div>
              <div className='gameText'>
                <h3>游戏解封申请</h3>
                <p>游戏内物品被盗申诉找回</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className='zxKf' onClick={() => window.location.href = 'http://kf.gyyx.cn/Home/IMIndex?opType=wegame'}></div>
    </div>
  );
};

export default KfIndex;
